import { render, staticRenderFns } from "./selectPassenger.vue?vue&type=template&id=6ef91c48"
import script from "./selectPassenger.vue?vue&type=script&lang=js"
export * from "./selectPassenger.vue?vue&type=script&lang=js"
import style0 from "./selectPassenger.vue?vue&type=style&index=0&id=6ef91c48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports